import { array, struct } from 'io-ts/Decoder';

import { Request as CreateRequest } from '../create';

export const Request = struct({
	layers: array(CreateRequest),
});
